// src/components/MobileBottomNav.tsx
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthProvider";

import iconHome from "../assets/nav/home.png";
import iconPlus from "../assets/nav/plus.png";
import iconList from "../assets/nav/payment-list.png";
import iconMy from "../assets/nav/mypage.png";

const ACTIVE = "#ff6a00";

export default function MobileBottomNav() {
  const { user } = useAuth();
  const nav = useNavigate();
  const location = useLocation();
  const { pathname, search, hash } = location;

  // ✅ 관리자/결제결과 같은 화면에서는 하단 탭 숨김
  const HIDE_PREFIXES = ["/admin", "/social-login", "/pay/success", "/pay/fail"];
  const hidden = HIDE_PREFIXES.some((p) => pathname.startsWith(p));
  if (hidden) return null;

  const isActivePath = (paths: string[]) =>
    paths.some((p) =>
      p.endsWith("*") ? pathname.startsWith(p.replace("*", "")) : pathname === p
    );

  const loginNext = (to: string) =>
    `/login?next=${encodeURIComponent(to || pathname + search + hash)}`;

  const items = [
    {
      key: "home",
      label: "홈",
      icon: iconHome,
      active: isActivePath(["/", "/m/home"]),
      onClick: () => nav("/m/home"),
    },
    {
      key: "register",
      label: "주문등록",
      icon: iconPlus,
      active: isActivePath(["/start", "/registration*", "/contracts*"]),
      onClick: () => {
        if (!user) nav(loginNext("/start"));
        else nav("/start");
      },
    },
    {
      key: "payments",
      label: "이용목록",
      icon: iconList,
      active: isActivePath(["/pay", "/pay-now"]),
      onClick: () => {
        if (!user) nav(loginNext("/pay"));
        else nav("/pay");
      },
    },
    {
      key: "mypage",
      label: "마이페이지",
      icon: iconMy,
      active: isActivePath(["/mypage", "/my"]),
      onClick: () => {
        if (!user) nav(loginNext("/mypage"));
        else nav("/mypage");
      },
    },
  ];

  return (
    <nav className="fixed inset-x-0 bottom-0 z-40 border-t border-slate-200 bg-white/95 backdrop-blur md:hidden">
      <div
        className="flex items-stretch justify-around text-[11px]"
        style={{
          paddingBottom: "env(safe-area-inset-bottom)",
          height: "calc(56px + env(safe-area-inset-bottom))",
        }}
      >
        {items.map((item) => {
          const inactiveIconStyle = {
            filter: "grayscale(1)",
            opacity: 0.45,
          } as const;

          return (
            <button
              key={item.key}
              type="button"
              onClick={item.onClick}
              className="flex flex-1 flex-col items-center justify-center gap-1"
              style={{ color: item.active ? ACTIVE : "#64748b" }}
            >
              <img
                src={item.icon}
                alt={item.label}
                className="h-6 w-6"
                loading="lazy"
                style={item.active ? undefined : inactiveIconStyle}
              />
              <span className={item.active ? "font-semibold" : ""}>
                {item.label}
              </span>
            </button>
          );
        })}
      </div>
    </nav>
  );
}
